import { createAxiosWithCache } from '@ori-appshell/shared';

import { DEFAULT_TRANSLATIONS } from '../models';

export interface TranslationsProviderResponse {
  [key: string]: string;
}

const axiosWithCache = createAxiosWithCache(15);

export const translationsProvider = async (
  baseUrl: string,
): Promise<TranslationsProviderResponse> => {
  const url = new URL('/system/ajax/Localization/Translate', baseUrl);
  const values = Object.values(DEFAULT_TRANSLATIONS);

  if (values.length > 0) {
    values.forEach((key: string) => {
      url.searchParams.append('keys', key);
    });
  }

  const { data } = await axiosWithCache.get<TranslationsProviderResponse>(url.toString());

  return data;
};
